import React from 'react';
import { Box, Typography } from '@mui/material';
import UserAvatar from '../UserAvatar';

const UserDetails = ({ user, label, size = 40 }) => {
  if (!user) return null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {label && (
        <Typography variant="subtitle2" color="text.secondary">
          {label}
        </Typography>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <UserAvatar user={user} size={size} />
        <Box>
          <Typography variant="subtitle1">
            {user.name}
          </Typography>
          {user.nickname && (
            <Typography variant="body2" color="text.secondary">
              {user.nickname}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default UserDetails;
